import React, { useEffect, useState } from 'react'
import SubmitButton from '../../components/controls/SubmitButton/SubmitButton'

import nexiLogo from "../.././assets/logo-nexi-group.png";
import styles from './NewCompany.module.css';
import { LegalEntityCompanyServicesApi, LegalEntityRegionServiceApi, LegalEntitySubsidiaryServicesApi } from '../../service';
import Loading from '../../components/Loading/Loading';
import GenericModal from '../../UI/GenericModal';
import { useHistory } from 'react-router-dom';
import DropdownSelect from '../../components/controls/DropdownSelect/DropdownSelect';
import { isSuperuserValue } from '../../access/access';

const NewCompany = () => {
  const [allSubsidiaries, setAllSubsidiaries] = useState();
  const [allRegions, setAllRegions] = useState();
  const [newCompanyName, setNewCompanyName] = useState("");
  const [subsidiaryId, setSubsidiaryId] = useState(0);
  const [regionId, setRegionId] = useState(0);
  const [authorityCode, setAuthorityCode] = useState("");
  const [isActiveCompany, setIsActiveCompany] = useState(true);
  
  const [isLoading, setIsLoading] = useState();
  const [error, setError] = useState();

  const [modalShow, setModalShow] = useState(false);
  const [modalAction, setModalAction] = useState();
  const [modalTitle, setModalTitle] = useState();
  const [modalMessage, setModalMessage] = useState();
  const [modalType, setModalType] = useState();

  const history = useHistory();

  useEffect(() => {
    if (!isSuperuserValue()) {
      history.push("/home");
    }
    let mounted = true;
    setIsLoading(true);

    const subsidiaryServices = new LegalEntitySubsidiaryServicesApi();
    subsidiaryServices.getAllLegalEntitySubsidiaries((subError, subsidiariesData) => {
      console.log("API all subsidiaries: ", subsidiariesData);
      if (mounted) {
        if (!subError) {
          setAllSubsidiaries(subsidiariesData.sort( (a,b) => a.id > b.id ? 1 : -1));
          const regionServiceApi = new LegalEntityRegionServiceApi();
          regionServiceApi.getAllLegalEntityRegions((regionError, regionsData) => {
            console.log("API all regions: ", regionsData);
            if (mounted) {
              if (!regionError) {
                setAllRegions(regionsData.sort( (a,b) => a.id > b.id ? 1 : -1));
              } else {
                setError(() => {
                  throw new Error ("");
                  // throw new Error ("Error " + (regionError.response ? regionError.response.statusCode : "") + " " + regionError.message);
                })
              }
            }
            setIsLoading(false);
          })
        } else {
          setError(() => {
            throw new Error ("");
            // throw new Error ("Error " + (subError.response ? subError.response.statusCode : "") + " " + subError.message);
          })
        }
    }
    });

    return (() => {
      mounted = false;
    })
  },[]);

  const companyNameHandler = (value) => {
    setNewCompanyName(value);
  }

  const authorityCodeHandler = (value) => {
    let val = value.replace(/[^A-Za-z0-9]/ig, '')
    val = val.toUpperCase();
    setAuthorityCode(val);
  }

  const subsidiaryChangeHandler = (subId) => {
    setSubsidiaryId(subId)
    console.log(allSubsidiaries.filter(el => el.id === subId))
  }

  const regionChangeHandler = (regId) => {
    setRegionId(regId);
  }

  const updateActiveCompanyValue = (value) => {
    console.log("Active value: ", value);
    setIsActiveCompany(value);
  }

  const submitFormHandler = () => {
    console.log("Submit function")
    
    if (validValues()) {
      setIsLoading(true);
      const requestBody = {
        name: newCompanyName,
        active: isActiveCompany,
        authorityCode: authorityCode,
        legalEntitySubsidiaryId: subsidiaryId,
        legalEntityRegionId: regionId
      }
      
      console.log("requestBody: ", requestBody);
      const companyServicesApi = new LegalEntityCompanyServicesApi();
      companyServicesApi.newLegalEntityCompany(requestBody, (error, data) => {
        if (!error) {
          setIsLoading(false);
          modalDataHandler("", `A new company "${newCompanyName}" was created`, 'notification', () => history.push("/company-monitor"))  
        } else {
          setIsLoading(false);
          modalDataHandler(``, "Error! The company was not created!", 'error', () => setModalShow(false));
          // modalDataHandler("", `An error ocurred. A new company could not be created! \n${error.message} ${error.response.statusCode}`, 'notification', () => history.push("/company-monitor"))  
        }
      })
    } else {
       modalDataHandler("", `A name must be typed for the new company.`, 'notification', modalCloseHandler)
    }
  }

  const validValues = () => {

    if (newCompanyName.length === 0 || authorityCode.length === 0 || subsidiaryId === 0 || regionId === 0) {
      return false;
    } else {
      return true;
    }
  }

  const modalDataHandler = (title, message, modType, action) => {
    setModalAction(() => action );
    setModalTitle(title);
    setModalMessage(message);
    setModalShow(true);
    setModalType(modType);
  }

  const modalCloseHandler = () => {
    setModalShow(false)
  }

  const requestBody = {
    name: newCompanyName,
    active: isActiveCompany,
    authorityCode: authorityCode,
    legalEntitySubsidiaryId: subsidiaryId,
    legalEntityRegionId: regionId
  }

  console.log("requestBody: ", requestBody);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        modalDataHandler(
          "Add Company",
          "Add new company?",
          "confirmation",
          submitFormHandler
        );
      }}
    >
      <GenericModal
        show={modalShow}
        handleClose={modalCloseHandler}
        action={modalAction}
        title={modalTitle}
        message={modalMessage}
        modalType={modalType}
      />
      <div className="d-flex justify-content-between mt-2">
        <div className="d-flex flex-column">
          <label className="fw-bold mb-1 ms-1">
            Company
          </label>
          <input
            className={styles.textInput}
            type="text"
            value={newCompanyName}
            onChange={(e) => {
              companyNameHandler(e.target.value);
            }}
            placeholder="Type company name"
          />
        </div>
        <div className="d-flex flex-column">
          <label className="fw-bold mb-1 ms-1">
            Authority Code
          </label>
          <input
            className={`${styles.textInput}`}
            type="text"
            // pattern="[A-Z0-9-]+"
            maxLength="9"
            size="14"
            value={authorityCode}
            onChange={(e) => {
              authorityCodeHandler(e.target.value);
            }}
            placeholder="Type authority code"
          />
        </div>
        <div className="d-flex flex-column align-items-center">
          <label htmlFor="active" className="mb-1 fw-bold">
            Active
          </label>
          <input
            type="checkbox"
            id="active"
            className={styles.activeCheckbox}
            name="activeValue"
            checked={isActiveCompany}
            onChange={(e) => {
              updateActiveCompanyValue(e.target.checked);
            }}
          />
        </div>
        <div>
          <img src={nexiLogo} className={`${styles.logo}`} alt="nexi-group" />
        </div>
      </div>
      <div className="hr position-relative mt-4"></div>
      {isLoading && <Loading height={"82px"} />}
      {!isLoading && (
        <div className="d-flex justify-content-between mb-4">
          <div className="d-flex">
            <div className="me-5">
              <label className="fw-bold mb-1 mt-4 ms-1">Subsidiary</label>
              {allSubsidiaries && (
                <DropdownSelect
                  data={allSubsidiaries}
                  name={"subsidiaries"}
                  emptyListMessage={"Select a Subsidiary"}
                  defaultValue={subsidiaryId}
                  onChange={subsidiaryChangeHandler}
                  //  onChange={event => controlFunctionChange(event)}
                ></DropdownSelect>
              )}
            </div>
            <div>
              <label className="fw-bold mb-1 mt-4 ms-1">Region</label>
              {allRegions && (
                <DropdownSelect
                  data={allRegions}
                  name={"regions"}
                  emptyListMessage={"Select a Region"}
                  defaultValue={regionId}
                  onChange={regionChangeHandler}
                  //  onChange={event => controlFunctionChange(event)}
                ></DropdownSelect>
              )}
            </div>
          </div>
          <div className="d-flex align-items-end">
            <SubmitButton
              type="submit"
              disabled={!validValues()}
              class={`${styles.submitButton} mt-3 mb-1 me-3 float-end`}
            >
              Add
            </SubmitButton>
          </div>
        </div>
      )}
    </form>
  );
}

export default NewCompany;
